import type { OAuthProvider } from '#modules/user/features/auth/constants/providers';

/**
 * Frontend OauthType value → teamplay-user `/oauth2/authorization/{path}` registration id.
 *
 * Typed as a total Record on purpose: a provider added to the UI without a path here compiles
 * to nothing visible, and the app reports "Could not start linking. Please try again." — which
 * is what Bungie did, since the map was written before that provider existed. The web build is
 * unaffected (there the gateway hands out the href), so the gap only ever shows up in the shell.
 *
 * Type-only import: nothing from the providers module reaches the bundle or the test runner.
 */
const PROVIDER_PATH: Record<OAuthProvider, string> = {
  GOOGLE: 'google',
  DISCORD: 'discord',
  STEAM: 'steam',
  EPIC_GAMES: 'epicgames',
  RIOT_GAMES: 'riotgames',
  BUNGIE: 'bungie',
  XBOX: 'xbox',
};

export const nativeOAuthProviderPath = (provider: string): string | undefined =>
  PROVIDER_PATH[provider as OAuthProvider];

export const nativeOAuthProviderPaths = PROVIDER_PATH;
